export default __webpack_public_path__ + "static/media/benf.6bd60baa.PNG";